import React from "react";

import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";

import WizardDescriptor from "@app/component/flows/types/WizardDescriptor";
import { IWizardStep, StepWithImage } from "@app/component/wizard";

import styles from "./MobileWizardStep.module.scss";

const messages = defineMessages({
  backButtonLabel: {
    id: "guides.mobileWizard.navigation.back",
    defaultMessage: "Back",
  },
  doneButtonLabel: {
    id: "guides.mobileWizard.navigation.done",
    defaultMessage: "Done",
  },
  nextButtonLabel: {
    id: "guides.mobileWizard.navigation.next",
    defaultMessage: "Next {nextIcon}",
  },
  progress: {
    id: "guides.mobileWizard.progress",
    defaultMessage: "Step {current}/{total}",
  },
});

export interface MobileWizardStepProps extends IWizardStep<WizardDescriptor> {}

const MobileWizardStep = ({
  onCancel,
  onFinish,
  onGoBack,
  onGoForward,
  state,
  stepIndex,
}: MobileWizardStepProps) => {
  const intl = useIntl();

  const step = state.steps[stepIndex];
  const isLastStep = stepIndex === state.steps.length - 1;

  return (
    <StepWithImage
      backButtonHidden={stepIndex < 1}
      backButtonText={intl.formatMessage(messages.backButtonLabel)}
      className={styles.container}
      image={<img alt={intl.formatMessage(step.title)} className={styles.image} src={step.image} />}
      nextButtonText={intl.formatMessage(
        isLastStep ? messages.doneButtonLabel : messages.nextButtonLabel,
        {
          nextIcon: <FontAwesomeIcon icon={faArrowRight} />,
        }
      )}
      onCancel={onCancel}
      onGoBack={onGoBack}
      onGoForward={isLastStep ? onFinish : onGoForward}
      title={
        <div className={styles.title}>
          {intl.formatMessage(state.title)}{" "}
          <span className={styles.progress}>
            {intl.formatMessage(messages.progress, {
              current: stepIndex + 1,
              total: state.steps.length,
            })}
          </span>
        </div>
      }
    >
      <div className={styles.info}>
        <div className={styles.title}>{intl.formatMessage(step.title)}</div>
        <div className={styles.description}>{intl.formatMessage(step.description)}</div>
      </div>
    </StepWithImage>
  );
};

export default MobileWizardStep;
